import { Facebook, Instagram, MapPin, Phone, Mail, Lock } from "lucide-react";
import { useTranslation } from "react-i18next";

const SOCIAL_LINKS = [
  { icon: Facebook, label: "Facebook", href: "https://www.facebook.com/share/1CXw9n31Dz/", testId: "social-facebook" },
  { icon: Instagram, label: "Instagram", href: "https://www.instagram.com/ancienne_poste_entrechaux/", testId: "social-instagram" },
];

export const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer
      data-testid="footer"
      className="bg-[#2C2420] text-white/80 pt-16 pb-8 md:pb-8 pb-24 px-6 md:px-12"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16 mb-16">
          {/* Brand */}
          <div>
            <img
              src="/logo.png"
              alt="L'Ancienne Poste"
              className="h-20 w-auto mb-4 brightness-110"
            />
            <p
              className="text-sm text-white/50 leading-relaxed max-w-xs"
              style={{ fontFamily: "'Lato', sans-serif", fontWeight: 300 }}
            >
              {t("footer.tagline")}
            </p>
          </div>

          {/* Contact */}
          <div>
            <p
              className="text-xs uppercase tracking-[0.2em] text-white/40 mb-5"
              style={{ fontFamily: "'Lato', sans-serif" }}
            >
              {t("footer.contact")}
            </p>
            <div className="space-y-3">
              <a
                href="https://maps.google.com/?q=243+Avenue+des+Princes+d'Orange+84340+Entrechaux"
                className="flex items-center gap-3 text-sm text-white/60 hover:text-[#C1624D] transition-colors duration-300"
                style={{ fontFamily: "'Lato', sans-serif" }}
                data-testid="footer-address"
              >
                <MapPin size={14} className="flex-shrink-0" />
                243 Av. des Princes d'Orange, 84340 Entrechaux
              </a>
              <a
                href="tel:+33490460984"
                className="flex items-center gap-3 text-sm text-white/60 hover:text-[#C1624D] transition-colors duration-300"
                style={{ fontFamily: "'Lato', sans-serif" }}
                data-testid="footer-phone"
              >
                <Phone size={14} />
                04 90 46 09 84
              </a>
              <a
                href="tel:+33634134035"
                className="flex items-center gap-3 text-sm text-white/60 hover:text-[#C1624D] transition-colors duration-300"
                style={{ fontFamily: "'Lato', sans-serif" }}
                data-testid="footer-phone-mobile"
              >
                <Phone size={14} />
                06 34 13 40 35
              </a>
              <a
                href="mailto:contact@ancienneposteentrechaux.com"
                className="flex items-center gap-3 text-sm text-white/60 hover:text-[#C1624D] transition-colors duration-300"
                style={{ fontFamily: "'Lato', sans-serif" }}
                data-testid="footer-email"
              >
                <Mail size={14} />
                contact@ancienneposteentrechaux.com
              </a>
            </div>
          </div>

          {/* Social */}
          <div>
            <p
              className="text-xs uppercase tracking-[0.2em] text-white/40 mb-5"
              style={{ fontFamily: "'Lato', sans-serif" }}
            >
              {t("footer.follow")}
            </p>
            <div className="flex items-center gap-4">
              {SOCIAL_LINKS.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon w-10 h-10 rounded-full border border-white/20 flex items-center justify-center
                             text-white/60 hover:text-[#C1624D] hover:border-[#C1624D] transition-all duration-300"
                  data-testid={social.testId}
                  aria-label={social.label}
                >
                  <social.icon size={18} />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Manager space discreet link */}
        <div className="flex justify-center md:justify-end mb-4">
          <a
            href="https://poste-admin-suite.emergent.host"
            target="_blank"
            rel="noreferrer"
            data-testid="manager-space-link"
            className="inline-flex items-center gap-1.5 text-xs text-white/30 hover:text-[#C1624D] transition-colors duration-300"
            style={{ fontFamily: "'Lato', sans-serif" }}
          >
            <Lock className="w-3 h-3" />
            {t("footer.manager_space")}
          </a>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row justify-between items-center gap-3">
          <p
            className="text-xs text-white/40 text-center md:text-left"
            style={{ fontFamily: "'Lato', sans-serif" }}
          >
            &copy; {new Date().getFullYear()} L'Ancienne Poste. {t("footer.rights")} · © Photos : Christophe Abbes
          </p>
          <p
            className="text-xs text-white/50 italic text-center"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '0.8rem' }}
            data-testid="design-credit"
          >
            {t("footer.design_credit")}
          </p>
          <p
            className="text-xs text-white/30 text-center md:text-right"
            style={{ fontFamily: "'Lato', sans-serif" }}
          >
            Entrechaux, Vaucluse
          </p>
        </div>
      </div>
    </footer>
  );
};
